const Spinner: React.SFC<{}> = () => {
  return (
    <div className="m-4 text-center">
      <span>Loading...</span>
    </div>
  );
};

export default Spinner;
